export const CUSTOM_SAVE = "CustomSave";
export const CUSTOM_SAVE_AND_CLOSE = "CustomSaveAndClose";
export const CUSTOM_PROCEED = "CustomProceed";
export const CUSTOM_BACK_TO_START = "CustomBackToStart";
export const CUSTOM_BACK_TO_PREVIOUS = "CustomBackToPrevious";
/**
 * For module "Dokumente versenden"
 */
export const SEND_MAIL_EVENT = "event_send_mail";
export const SEND_MAIL_BUND_ID_EVENT = "event_send_mail_bund_id";
/**
 * For module "Informationen nachfordern"
 */
export const SEND_MAIL_INFORMATAION_REQUEST_EVENT = "send_email_information_request";
export const SHOW_WIEDERVORLAGEN_EVENT = "showWiedervorlagen";
export const SHOW_CHANGELOG_EVENT = "showChangelog";
export const SHOW_FRISTEN_EVENT = "showFristen";
export const SHOW_LINKS_EVENT = "showLinks";
export const CHANGE_ASSIGNMENT_EVENT = "changeAssignment";
export const CREATE_GEBUEHRENFORDERUNG = "create_gebuehrenforderung";
export const CREATE_ZAHLUNGSVORGANG_EPAYBL = "create_zahlungsvorgang_epaybl";
export const GET_ZAHLUNGSVORGANGSTATUS_EPAYBL = "get_zahlungsvorgangstatus_epaybl";

export const CREATE_XFINANZ_DATEI = "create_xfinanz_datei";
export const DELETE_XFINANZ_DATEI = "delete_xfinanz_datei";

export const UPSERT_OPENREGISTER_RECORD = "upsert_openregister_record";
export const SELECT_OPENREGISTER_RECORD_ID = "select_openregister_record_id";

export const OPEN_OPENREGISTER_SEARCH_MODAL = "open_openregister_search_modal";
export const REFRESH_OPENREGISTER_RECORD = "refresh_openregister_record";

export const GENERATE_PDF_EVENT = "generieren_event";
export const DELETE_PDF_EVENT = "generiertes_Dokument_loeschen_event";
export const SIGN_PDF_EVENT = "signieren_event";
export const DOWNLOAD_SIGNED_PDF_EVENT = "signiertes_dokument_herunterladen_event";
